import { useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import { TABS_TRAFFIC, TRAFFIC_SUB_VIEW_MODEL } from '../Model/Model';
import { permissionObj } from '../../../../Helpers/permission';
import {MODAL_NAMES, toggleFinesModal} from '../FineTypes/Model/Model';
import routes from '../../../../Routes/routes';
import {TAB_OPTIONS} from "../TrafficFines/Model/Model";
import {MODELS} from "../../../../Apis/Models";
import {TABLES} from "../../../../Apis/Tables";
/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 */
export const TrafficMainApp = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    let { state } = location;
    const currentTab = state?.currentTab;
    const currentSubView = state?.currentSubView;
    const [steps, setSteps] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    const [selectedList, setSelectedList] = useState([]);
    const [subView, setSubView] = useState(null);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const [searchElement, setSearchElement] = useState('');
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [showFinesModal, setShowFinesModal] = useState(false)
    const { fineType, setFineType } = useOutletContext();
    const [selectedInnerView, setSelectedInnerView] = useState(TAB_OPTIONS.GEOFENCES);
    const [modified, setModified] = useState(false);
    const finesSubviewRef = useRef();
    const [search, setSearch] = useState(false); // Search flag
    const [bodyForExport, setBodyForExport] = useState(''); // Data to export
    const [criteria, setCriteria] = useState();
    const [moduleId, setModuleId] = useState(null);
    const [option, setOption] = useState(null);

    // Handles initial setup of tabs and subviews based on user permissions
    useLayoutEffect(() => {
        let activeTab = null;

        // Configuration of tabs and their required permissions
        const stepConfig = [
            {
                tab: TABS_TRAFFIC.TRAFFIC_FINES.TRANS,
                perm: [permissionObj?.WEB_TRAFFIC_DASHBOARD_GEOFENCES_READ, permissionObj?.WEB_TRAFFIC_DASHBOARD_FINES_READ, permissionObj?.WEB_TRAFFIC_USERS_READ], //change to traffic
                index: TABS_TRAFFIC.TRAFFIC_FINES.INDEX,
            },
            {
                tab: TABS_TRAFFIC.MANAGE.TRANS,
                perm: [permissionObj?.WEB_TRAFFIC_MANAGE_FINES_READ, permissionObj?.WEB_TRAFFIC_MANAGE_GEOFENCES_READ],
                index: TABS_TRAFFIC.MANAGE.INDEX,
            },
            {
                tab: TABS_TRAFFIC.FINES_TYPES.TRANS,
                perm: [permissionObj?.WEB_FINE_TYPE_READ],
                index: TABS_TRAFFIC.FINES_TYPES.INDEX,
            },
        ];

        // Build list of visible tabs based on user permissions
        const auxStep = stepConfig.reduce((acc, { tab, perm, index }) => {
            const hasPermission = DEV || perm.some((p) => permission?.includes(p));
            if (hasPermission) {
                acc.push({ label: t(tab), index: index });
                if (activeTab === null) activeTab = index;
            }
            return acc;
        }, []);
        setSteps(auxStep);
        // If a default tab hasn't been set, initialize it
        if (activeTab !== null && !currentTab) handleStepChange(activeTab);
    }, [t, permission]);

    /**
     * Calls `handleStepChange` whenever the `location` changes,
     * ensuring the current tab is updated immediately before painting.
     *
     * useLayoutEffect is used instead of useEffect to avoid visual glitches
     * when the tab state updates in response to route/location changes.
     */
    useLayoutEffect(() => {
        if(currentTab) handleStepChange(currentTab);
    }, [location]);

    // Handles tab change: updates active step, resets selection, updates view
    const handleStepChange = (step) => {
        setActiveStep(step);
        setSelectedList([]);
        navigate(location.pathname, { replace: true, state: {} });
        subViewChange(step);
    };

    // Handles tab change
    const handleStepSelectedInnerView = (tab) => {
        setSelectedInnerView(tab);
        switch (tab) {
            case  TAB_OPTIONS.FINES:
                setModuleId(MODELS.TRAFFIC_DASHBOARD_FINES);
                setOption(TABLES.FINE);
                setSearch(true);
                break;

            case TABS_TRAFFIC.MANAGE.INDEX:
            default:
                setModuleId(null);
                setOption(null)
                setSearch(false);
                break;
        }
    };

    const handleSelectedInnerView = () => {
        const hasGeofencesPermission = permission.includes(permissionObj?.WEB_TRAFFIC_DASHBOARD_GEOFENCES_READ);
        const hasFinesPermission = permission.includes(permissionObj?.WEB_TRAFFIC_DASHBOARD_FINES_READ);

        if (hasGeofencesPermission) {
            setSelectedInnerView(TAB_OPTIONS.GEOFENCES)
        } else if(hasFinesPermission){
            setSelectedInnerView(TAB_OPTIONS.FINES);
        }
    };



    // Determines the subview to load for a specific tab
    const subViewChange = (step) => {

        let subView;
        switch (step) {
            case TABS_TRAFFIC.TRAFFIC_FINES.INDEX:
                const dashGeo = DEV || permission?.includes(permissionObj.WEB_TRAFFIC_DASHBOARD_GEOFENCES_READ)
                    || permission?.includes(permissionObj.WEB_TRAFFIC_DASHBOARD_FINES_READ);
                const dashUsers = DEV || permission?.includes(permissionObj.WEB_TRAFFIC_USERS_READ);

                if(currentSubView === TRAFFIC_SUB_VIEW_MODEL.TRAFFIC_FINES.DASHBOARD || dashGeo){
                    subView = currentSubView || TRAFFIC_SUB_VIEW_MODEL.TRAFFIC_FINES.DASHBOARD;
                    if(selectedInnerView === TAB_OPTIONS.FINES){
                        setModuleId(MODELS.TRAFFIC_DASHBOARD_FINES);
                        setOption(TABLES.FINE);
                        setSearch(true);
                    }
                    else{
                        setModuleId(null);
                        setOption(null);
                        setSearch(false);
                    }
                    handleSelectedInnerView()//Only dashboard has inner view
                }else if(currentSubView === TRAFFIC_SUB_VIEW_MODEL.TRAFFIC_FINES.USERS  || dashUsers) {
                    subView = currentSubView || TRAFFIC_SUB_VIEW_MODEL.TRAFFIC_FINES.USERS
                    setModuleId(MODELS.TRAFFIC_USERS);
                    setOption(TABLES.FINE_USER)
                    setSearch(false);
                }
                setSubView(subView);
                break;

            case TABS_TRAFFIC.MANAGE.INDEX:
                const manageFines = DEV || permission?.includes(permissionObj.WEB_TRAFFIC_MANAGE_FINES_READ);
                const manageGeos = DEV || permission?.includes(permissionObj.WEB_TRAFFIC_MANAGE_GEOFENCES_READ);

                if(currentSubView === TRAFFIC_SUB_VIEW_MODEL.MANAGE.FINES || manageFines){
                    subView = currentSubView || TRAFFIC_SUB_VIEW_MODEL.MANAGE.FINES;
                    setModuleId(null);
                    setOption(null)
                }else if(currentSubView === TRAFFIC_SUB_VIEW_MODEL.MANAGE.GEOFENCES  || manageGeos) {
                    subView = currentSubView || TRAFFIC_SUB_VIEW_MODEL.MANAGE.GEOFENCES
                    setModuleId(null);
                    setOption(null)
                }
                setSubView(subView);
                break;
        }
    };

    // Utility to validate if the current user has the required permission for a specific button list
    const permissionButtons = (list) => {
        const permissionRequired = list[activeStep];
        if (!permissionRequired) {
            return false;
        }
        return DEV || permission?.includes(permissionRequired);
    };

    const handleCreate = (activeStep) => {
        switch (activeStep) {
            case TABS_TRAFFIC.TRAFFIC_FINES.INDEX:
                if (subView === TRAFFIC_SUB_VIEW_MODEL.TRAFFIC_FINES.DASHBOARD) {
                    toggleFinesModal(MODAL_NAMES.CREATE, setShowFinesModal);
                }
                break;

            case TABS_TRAFFIC.MANAGE.INDEX:
                if(subView === TRAFFIC_SUB_VIEW_MODEL.MANAGE.GEOFENCES)
                    navigate(routes.geofences.create, {
                        state: { currentTab: TABS_TRAFFIC.MANAGE.INDEX, currentSubView: TRAFFIC_SUB_VIEW_MODEL.MANAGE.GEOFENCES },
                    });
                break;

            case TABS_TRAFFIC.FINES_TYPES.INDEX:
                toggleFinesModal(MODAL_NAMES.CREATE, setFineType)
                break;
            default:
                break;
        }
    }

    const handleUpdate = () => {
        switch (activeStep) {
            case TABS_TRAFFIC.FINES_TYPES.INDEX:
                toggleFinesModal(MODAL_NAMES.CREATE, setFineType, false)
                break;

            case TABS_TRAFFIC.MANAGE.INDEX:
                if (subView === TRAFFIC_SUB_VIEW_MODEL.MANAGE.FINES) {
                    if (finesSubviewRef.current)
                        finesSubviewRef.current.updateData();
                }
                break;
            case TABS_TRAFFIC.TRAFFIC_FINES.INDEX:
                break;

            default:
                break;
        }
    }

    const handleDelete = () => {
        switch (activeStep) {
            case TABS_TRAFFIC.FINES_TYPES.INDEX:
                if (fineType.selectForDelete.length > 0)
                    toggleFinesModal(MODAL_NAMES.DELETE, setFineType)
                break;
        }
    }

    return {
        DEV,
        navigate,
        permission,
        permissionButtons,
        subView,
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        setSubView,
        setSearchElement,
        searchElement,
        handleCreate,
        showFinesModal,
        setShowFinesModal,
        handleDelete,
        modified,
        finesSubviewRef,
        handleUpdate,
        selectedInnerView,
        handleStepSelectedInnerView,
        search, setSearch,
        bodyForExport, setBodyForExport,
        criteria, setCriteria,
        moduleId, setModuleId,
        option, setOption,
        fineType
    };
};

